import { IGetAllLogAlteracaoUseCase } from "../../../presentation/useCases/read/get_all_log_alteracao_use_case";
import { LogTipoTabela } from "../../../utils/log_tabela_tipo";
import { LogAlteracao } from "../../models/log_alteracao";
import { ICommonsRepository } from "../../repositories/commons_repository";
import { BasePaginatedUseCase } from "../base_paginated_use_case";

/**
 * GetAllLogAlteracaoUseCase
 */

export class GetAllLogAlteracaoUseCase extends BasePaginatedUseCase<LogAlteracao> implements IGetAllLogAlteracaoUseCase {
  constructor(private readonly repository: ICommonsRepository) {
    super();
  }

  async getAllLogAlteracao(
    tipoTabela: LogTipoTabela,
    idTabela: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllLogAlteracao(
      tipoTabela,
      idTabela,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
